import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Workbook as wb} from "exceljs";
import {UtilsService} from "../../../../shared/utils/utils.service";
import {
  LfsaBotonEditarGridComponent
} from "../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component";
import {moduloHorasExtras} from "../../diccionarios/horas-extrasModulo";
import {ParametrizacionTipoTurnoService} from "../../services/parametrizacion-tipo-turno.service";
import {notWhiteSpacesValidator} from "../../../../shared/validators/notWhiteSpacesValidator";

@Component({
  selector: 'app-parametrizacion-tipo-turno',
  templateUrl: './parametrizacion-tipo-turno.component.html',
  styleUrls: ['./parametrizacion-tipo-turno.component.css']
})
export class ParametrizacionTipoTurnoComponent implements OnInit {

  mostrarFormulario: boolean = false;
  mostrarGridLista: boolean = true;
  titulo: string;
  DAT_TITULOS: any;
  DAT_BTNCSS: any;
  DAT_MSG: any;
  DAT_BTNS: any;
  textBoton: string;
  editableForm: boolean = false;
  formulario: FormGroup;
  formularioMarcacion: FormGroup;
  loading: boolean = false;
  diccionarioModulo: any = {};
  frameworkComponents: any;
  columnDefs: any[];
  rowData: any[];
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;
  obligatorylocality: boolean = false;
  today: any;
  cmbDepartment: any[] = [];
  cmbEmployees: any[] = [];

  workbook: wb;
  data: any = [];
  dataExcel: any = [];
  uploadForm: FormGroup;
  actualWeek: number;
  recursosHumanos = false;
  @ViewChild('fileInput') fileInput: ElementRef;


  constructor(
    private fb: FormBuilder,
    private _parametrizacionTipoTurnoService: ParametrizacionTipoTurnoService,
    private _util: UtilsService,
  ) {
    this.diccionarioModulo = moduloHorasExtras;
  }

  ngOnInit(): void {
    this.DAT_BTNS = moduloHorasExtras.button.buttonsNombre;
    this.DAT_TITULOS = moduloHorasExtras.titulos.parametrizacionTipoTurno;
    this.DAT_BTNCSS = moduloHorasExtras.button.buttonsCss;
    this.DAT_MSG = moduloHorasExtras.mensajes;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.getAllTipoTurno();
    this.formulario = this.fb.group({
      id: ['', [Validators.required, notWhiteSpacesValidator()]],
      description: ['', [Validators.required]],
      entrada1: ['', []],
      salida1: ['', []],
      entrada2: ['', []],
      salida2: ['', []],
      entrada3: ['', []],
      salida3: ['', []],
    });
    this.girdComponent();
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getMondayOfCurrentWeek(dateNew) {
    const day = new Date(dateNew);
    const first = day.getDate() - day.getDay() + (day.getDay() === 0 ? -6 : 1);
    const monday = new Date(day.setDate(first));
    return monday;
  }

  getSundayOfCurrentWeek(dateNew) {
    const day = new Date(dateNew);
    const first = day.getDate() - day.getDay() + (day.getDay() === 0 ? 0 : 7);
    const sunday = new Date(day.setDate(first));
    return sunday;
  }

  addDays(date, days) {
    const copy = new Date(Number(date))
    copy.setDate(date.getDate() + days)
    return copy
  }

  formatoFecha(date) {
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    return `${day < 10 ? '0' + day : day}-${month < 10 ? '0' + month : month}-${year}`;
  }


  changeYear() {
    if (this.formulario.get('year').value) {
      //this.calculateWeeks(this.formulario.get('year').value);
    }
  }

  validateDate(firtDateF, secondDateF) {
    let firtDate = this.getMondayOfCurrentWeek(firtDateF);
    let secondDate = this.getMondayOfCurrentWeek(secondDateF);
    if ((firtDate.getDate() === secondDate.getDate()) && (firtDate.getFullYear() === secondDate.getFullYear()) && (firtDate.getMonth() === secondDate.getMonth())) {
      return true;
    } else {
      return false;
    }
  }


  getAllTipoTurno() {
    this.loading = true;
    this._parametrizacionTipoTurnoService.getAll().subscribe((res: any) => {
      this.rowData = res;
      this.loading = false;
    }, () => {
      this.loading = false;
      this.rowData = [];
    });
  }


  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'ID',
        field: 'id',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'TURNO',
        field: 'turno',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'ENTRADA 1',
        field: 'entrada1',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'SALIDA 1',
        field: 'salida1',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'ENTRADA 2',
        field: 'entrada2',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'SALIDA 2',
        field: 'salida2',
        sortable: true,
        filter: true,
        width: 150
      }, {
        headerName: 'ENTRADA 3',
        field: 'entrada3',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'SALIDA 3',
        field: 'salida3',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.editarTipoTurno.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.eliminarTipoTurno.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
    ];
    this.rowSelection = 'single';
  }

  editarTipoTurno({rowData}) {
    this.titulo = this.DAT_TITULOS.tituloCardEditar;
    this.mostrarGridLista = false;
    this.textBoton = this.DAT_BTNS.editar;
    this.editableForm = true;

    this.formulario.get('id').setValue(rowData.id);
    this.formulario.get('description').setValue(rowData.turno);
    this.formulario.get('entrada1').setValue(rowData.entrada1);
    this.formulario.get('salida1').setValue(rowData.salida1);
    this.formulario.get('entrada2').setValue(rowData.entrada2);
    this.formulario.get('salida2').setValue(rowData.salida2);
    this.formulario.get('entrada3').setValue(rowData.entrada3);
    this.formulario.get('salida3').setValue(rowData.salida3);

  }

  getDayToInputFormat(newDate) {
    const date = new Date(newDate);
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let dayFormat = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
    return dayFormat;
  }

  getHourToInputFormat(newDate) {
    const date = new Date(newDate);
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let dayFormat = `${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}`;
    return dayFormat;
  }

  regresar() {
    this.formulario.reset();
    this.mostrarGridLista = true;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
  }

  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
        this.actualizarTipoTurno();
      } else {
        this.guardarTipoTurno();
      }
    } else {
      this.titulo = this.DAT_TITULOS.tituloCardListar;
      this.mostrarGridLista = true;
    }
  }

  guardarTipoTurno() {
    const payload = this.formatPayload();
    payload.id = payload.id ? payload.id.trim() : payload.id;
    if (payload.turnos.length === 0) {
      this._util.mensajeErrorVisto('Debe colocar por lo menos un rango de turno', true, 9000);
      return;
    }
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.guardar,
        text: ``,
        action: this.DAT_BTNS.guardar,
        funcion: this._parametrizacionTipoTurnoService.createTipoTurno(payload),
        loading: true,
        context: this
      }
    ).then((res: any) => {
      this.getAllTipoTurno();
      this.regresar();
    });
  }

  formatPayload() {
    const payload = {
      "id": this.formulario.get('id').value,
      "description": this.formulario.get('description').value,
      "turnos": []
    }
    if (this.formulario.get('entrada1').value && this.formulario.get('salida1').value) {
      payload.turnos.push(
        {
          "horaEntrada": this.formulario.get('entrada1').value,
          "horaSalida": this.formulario.get('salida1').value
        }
      );
    }
    if (this.formulario.get('entrada2').value && this.formulario.get('salida2').value) {
      payload.turnos.push(
        {
          "horaEntrada": this.formulario.get('entrada2').value,
          "horaSalida": this.formulario.get('salida2').value
        }
      );
    }
    if (this.formulario.get('entrada3').value && this.formulario.get('entrada3').value) {
      payload.turnos.push(
        {
          "horaEntrada": this.formulario.get('entrada3').value,
          "horaSalida": this.formulario.get('salida3').value
        }
      );
    }
    return payload;
  }

  actualizarTipoTurno() {
    const payload = this.formatPayload();
    if (payload.turnos.length === 0) {
      this._util.mensajeErrorVisto('Debe colocar por lo menos un rango de turno', true, 9000);
      return;
    }
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.actualizar,
        text: ``,
        action: this.DAT_BTNS.editar,
        funcion: this._parametrizacionTipoTurnoService.update(payload),
        loading: true,
        context: this
      }
    ).then((res: any) => {
      this.getAllTipoTurno();
      this.regresar();
    });
  }

  eliminarTipoTurno({rowData}) {
    this._util.confirmarSincronoPromesa(
      {
        title: this.DAT_MSG.eliminar,
        text: ``,
        action: this.DAT_BTNS.eliminar,
        funcion: this._parametrizacionTipoTurnoService.delete(rowData),
      }
    ).then((res: any) => {
      this.gridApi.updateRowData({remove: this.gridApi.getSelectedRows()});
    });
  }

  nuevo() {
    this.titulo = this.DAT_TITULOS.tituloCardGuardar;
    this.mostrarGridLista = false;
    this.textBoton = this.DAT_BTNS.guardar;
    this.editableForm = false;
    this.formulario.reset();
  }
}
